import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiResponse} from '../../api/api-response';
import {ApiClientService} from '../api-client/api-client.service';
import {Language} from '../../models/language';

@Injectable({
  providedIn: 'root'
})
export class LangService {

  languageNames = new Intl.DisplayNames(["en"], {type: "language"});

  constructor(private apiClient: ApiClientService) {
  }

  getFlag(lang: string): string {
    return '/images/lang/' + lang + '.svg';
  }

  getLanguageFlag(language: Language): string {
    return '/images/lang/' + language.isoCode + '.svg';
  }

  getName(language: string): string | null {
    if (language) {
      return this.languageNames.of(language) ?? null;
    }

    return '';
  }

  getLanguages(): Observable<Language[]> {
    return new Observable<Language[]>((subscriber) => {
      this.apiClient.get('/language').subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData()['languages'].map((isoCode: string) => {
            let language = new Language();
            language.isoCode = isoCode;
            language.name = this.getName(isoCode) ?? '';
            return language;
          }).sort((a: Language, b: Language) => a.name.localeCompare(b.name)));
          subscriber.complete();
        }, error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }

  create(language: string): Observable<void> {
    return new Observable<void>((subscriber) => {
      this.apiClient.post('/language', {}, {isoCode: language}).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next();
          subscriber.complete();
        }, error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }

  delete(language: Language): Observable<void> {
    return new Observable<void>((subscriber) => {
      this.apiClient.delete('/language/' + language.isoCode).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next();
          subscriber.complete();
        }, error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }

  getAllLanguages(): Observable<string[]> {
    return new Observable<string[]>((subscriber) => {
      this.apiClient.get('/language/all').subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData()['languages']);
          subscriber.complete();
        }, error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }
}
